import { css } from 'lit';

export default css`
  :host {
    display: block;
  }

  :host([inverted]) li > a {
    color: var(--sl-color-link-inverted-idle);
  }

  :host([inverted]) li > a:focus-visible {
    outline-color: var(--sl-color-border-inverted);
  }

  :host([inverted]) li > a:hover {
    color: var(--sl-color-link-inverted-hover);
  }

  :host([inverted]) li > a:active {
    color: var(--sl-color-link-inverted-active);
  }

  :host([inverted]) li > a[aria-current='page'] {
    color: var(--sl-color-link-inverted-idle);
  }

  :host([inverted]) sl-icon[name='breadcrumb-separator'] {
    color: var(--sl-color-border-inverted);
  }

  ul {
    align-items: center;
    display: flex;
    gap: var(--sl-size-100);
    margin: 0;
    padding: 0;
  }

  li {
    display: block;
    list-style: none;
    min-inline-size: 0;
  }

  li.home {
    flex-shrink: 0;
  }

  li.home a {
    align-items: center;
    display: flex;
    gap: var(--sl-size-050);
  }

  li.more-menu {
    flex-shrink: 0;
  }

  li:not(:has(a)) {
    padding: var(--sl-size-100);
  }

  a {
    color: var(--sl-color-link-muted-idle);
    display: block;
    overflow: clip visible;
    padding: var(--sl-size-100);
    text-decoration: underline;
    text-decoration-thickness: var(--sl-size-borderWidth-default);
    text-overflow: ellipsis;
    text-underline-offset: var(--sl-size-025);
    white-space: nowrap;
  }

  a:hover {
    color: var(--sl-color-link-muted-hover);
    text-decoration-thickness: var(--sl-size-borderWidth-bold);
  }

  a:active {
    color: var(--sl-color-link-muted-active);
  }

  a:focus-visible {
    border-radius: var(--sl-size-borderRadius-default);
    outline: var(--sl-size-outlineWidth-default) solid var(--sl-color-border-focused);
    outline-offset: var(--sl-size-offset-focused);
  }

  a[aria-current='page'] {
    color: var(--sl-color-foreground-plain);
    text-decoration: none;
  }

  @media (width <= 600px) {
    a {
      padding-block: var(--sl-size-100);
    }
  }

  sl-icon[name='breadcrumb-separator'] {
    color: var(--sl-color-border-plain);
  }

  sl-popover::part(container) {
    display: flex;
    flex-direction: column;
    gap: var(--sl-size-100);
    padding: var(--sl-size-050) 0;
  }
`;
